import React, { Component } from 'react'
import { reaction } from 'mobx'
import { observer, inject } from 'mobx-react'

import GoodsItem from './GoodsItem'

import api from '../services'
import utils from '../utils'
const { $, FE } = utils

@inject('cityInfo')
@inject('lzLayState')
@observer
export default class Header extends Component {
  constructor(props){
    super(props)
    this.state = {
      searchList: [],
      minPriceList: [],
      showRes: false
    }

    this.keyWordRef = React.createRef()

    this.onSearch = this.onSearch.bind(this)
    this.getPrice = this.getPrice.bind(this)
    this.handleEnterKey = this.handleEnterKey.bind(this)
    this.getMinPrice = this.getMinPrice.bind(this)

    reaction(
      () => this.props.cityInfo.info.cityId,
      cityId => {
        if(this.state.showRes) this.getPrice()
      }
    )
  }

  onSearch(){
    let keyword = this.keyWordRef.current.value,
    { lzLayState } = this.props
    if(!keyword.trim()){
      $.toast({
        text: '请先输入内容再搜索',
        duration: 2000,
      })
      return
    }

    api.searchItem({
      pageSize: 10,
      keyWord: keyword,
      businessFlagType: 0,
      businessFlag: '1,6,7,8,11,12,14,15,16,17'
    }).then(data => {
      let { result, returncode } = data
      if(returncode === 0 && result && result.count > 0){
        lzLayState.hide()

        this.setState({
          searchList: result.list
        },this.getPrice)
      }else {
        this.setState({
          searchList: [],
          minPriceList: [],
          showRes: false
        })
        lzLayState.show('search')
      }
    })
    .catch(err => {
      $.toast({
        text: err.message,
        duration: 2000,
      })
    })
  }

  getPrice(){
    let { cityInfo } = this.props

    api.getPriceForList({
      city: cityInfo.info.cityId,
      itemIds: this.state.searchList.map(item => item.itemId).join(',')
    }).then(data => {
      if(data.returncode === 0){
        this.setState({
          minPriceList: data.result,
          showRes: true
        })
      }
    }).catch(()=>{})
  }
  
  handleEnterKey(e){
    if(e.nativeEvent.keyCode === 13){
      e.preventDefault()
      this.onSearch()
      this.keyWordRef.current.blur()
    }
  }

  getMinPrice(itemId) {
    let list = this.state.minPriceList
    return list.length ?
              list.filter(item => item.item.itemId === itemId)[0] ?
                list.filter(item => item.item.itemId === itemId)[0].minPrice
                  :
                  0
              :
              0
  }

  render(){
    let { cityInfo } = this.props,
    searchResList = this.state.searchList.map(
      item => <GoodsItem key={Math.random()}
                        goods={item}
                        minPrice={this.getMinPrice(item.itemId)}
                        cityName={cityInfo.info.cityName}
                        city={cityInfo.info.cityId} />
    )
    
    return(
      <div className={this.state.showRes?'header-wrap header-showRes':'header-wrap'}>
        <div className='header-search'>
          <a className={FE.APP.IS_APP?'fn-hide':'header-back'} href="javascript:history.back();">
          </a>
          <p className='header-position' onClick={cityInfo.show}>{cityInfo.info.cityName}</p>
          <form action="">
            <input className='header-input' 
                  autoComplete='off' 
                  type="search" 
                  ref={this.keyWordRef} 
                  onKeyPress={this.handleEnterKey} />
          </form>
        </div>
        <div className={this.state.showRes?'header-result':'header-result fn-hide'}>
          <span className='header-result-close' onClick={() => this.setState({showRes: false})}></span>
          { searchResList }
        </div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/Header.js